import * as React from 'react';
import { Card, Col, Form, Row, Container, Button } from 'react-bootstrap';
import { getUniversityboard, PostLastQualifyingDetails, getLastQualifyingDetails } from "../../api/studentDetails"
import { useEffect, useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function LastQualifyingExam(courseId) {
    // console.log("courseId", courseId);
    const [error, setError] = useState('');
    const [university, setUniversity] = useState([]);
    const [selectedUniversity, setSelectedUniversity] = useState('');
    const [errors, setErrors] = useState({});
    const [formData, setFormData] = useState({
        courseId: '',
        isAppear: 'false',
        lastExamName: '',
        universityAndBoardId: '',
        college: '',
        passingYear: '',
        obtainedMarks: '',
        totalMarks: '',
        stream: '',
        gap: 'false',
        lastExamSeatNo: '',
        result: '',
        percentage: ''
    });
    const token = typeof window !== "undefined" ? localStorage.getItem("token") : null;
    const studentId = typeof window !== "undefined" ? localStorage.getItem("id") : null;

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= currentYear - 20; i--) {
            years.push(i);
        }
        return years;
    };

    const fetchUniversityBoardData = async () => {
        try {
            const universityResponse = await getUniversityboard(token);
            setUniversity(universityResponse.data);
            console.log("University response:", universityResponse.data);
        } catch (error) {
            setError("Error fetching university and board data:", error);
        }
    };


    // Separate function to fetch last qualifying details
    const fetchLastQualifyingDetails = async () => {
        try {
            const existingDetailsResponse = await getLastQualifyingDetails(token, studentId, courseId.courseId);
            if (existingDetailsResponse.data) {
                console.log("Existing details:", existingDetailsResponse.data);
                setFormData({
                    courseId: existingDetailsResponse.data.courseId || '',
                    isAppear: existingDetailsResponse.data.isAppear ? 'true' : 'false',
                    lastExamName: existingDetailsResponse.data.lastExamName || '',
                    universityAndBoardId: existingDetailsResponse.data.universityAndBoard?.id || '',
                    universityBoardName: existingDetailsResponse.data.universityAndBoard?.universityBoardName || '',
                    college: existingDetailsResponse.data.college || '',
                    passingYear: existingDetailsResponse.data.passingYear || '',
                    obtainedMarks: existingDetailsResponse.data.obtainedMarks || '',
                    totalMarks: existingDetailsResponse.data.totalMarks || '',
                    stream: existingDetailsResponse.data.stream || '',
                    gap: existingDetailsResponse.data.gap ? 'true' : 'false',
                    lastExamSeatNo: existingDetailsResponse.data.lastExamSeatNo || '',
                    result: existingDetailsResponse.data.result || '',
                    percentage: existingDetailsResponse.data.percentage || '',
                });
            }
        } catch (error) {
            setError("Error fetching last qualifying details:", error);
        }
    };

    useEffect(() => {
        fetchUniversityBoardData();
        fetchLastQualifyingDetails();
    }, [token]);

    const handleBoardChange = (event) => {
        const selectedId = event.target.value;
        setSelectedUniversity(selectedId);

        const selectedUniversity = university.find((data) => data.id === parseInt(selectedId, 10));
        setFormData({
            ...formData,
            universityAndBoardId: selectedId,
            universityBoardName: selectedUniversity?.universityBoardName || '',
        });
        setErrors(prevErrors => ({
            ...prevErrors,
            universityAndBoardId: undefined
        }));
    };


    const handleChange = (e) => {
        const { name, value } = e.target;

        let errorMessage = "";
        let filteredValue = value;

        const numericFields = ["obtainedMarks", "totalMarks"];
        const textOnlyFields = ["stream"];
        const alphanumericFields = ["lastExamSeatNo", "lastExamName"];
        const percentageFields = ["percentage"];

        if (numericFields.includes(name)) {
            const numericRegex = /^[0-9]*$/;
            if (!numericRegex.test(value)) {
                errorMessage = "Only numbers are allowed";
                filteredValue = formData[name] || "";
            }
        } else if (textOnlyFields.includes(name)) {
            const textOnlyRegex = /^[A-Za-z\s]*$/;
            if (!textOnlyRegex.test(value)) {
                errorMessage = "Only letters are allowed";
                filteredValue = formData[name] || "";
            }
        } else if (alphanumericFields.includes(name)) {
            const alphanumericRegex = /^[A-Za-z0-9]*$/;
            if (/^\d+$/.test(value)) {
                errorMessage = "Only numbers are not accepted (must include letters)";
                filteredValue = formData[name] || "";
            } else if (!/^[A-Za-z0-9\s]*$/.test(value)) {
                errorMessage = "Only alphanumeric values are allowed";
                filteredValue = formData[name] || "";
            }
        }
        else if (percentageFields.includes(name)) {
            const percentageRegex = /^(100(\.0{0,2})?|[0-9]{1,2}(\.[0-9]{0,2})?)?$/;

            if (value === "") {
                errorMessage = "";
            }
            else if (!percentageRegex.test(value)) {
                errorMessage = "Must be a number between 0 and 100 with up to 2 decimal places";
                filteredValue = formData[name] || "";
            }
            else {
                const numericValue = parseFloat(value);
                if (!isNaN(numericValue) && (numericValue < 0 || numericValue > 100)) {
                    errorMessage = "Must be between 0 and 100";
                    filteredValue = formData[name] || "";
                }
            }
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: errorMessage || undefined,
        }));
    };


    const handleSave = async () => {

        const newErrors = {};
        if (!formData.passingYear) errors.passingYear = 'Country is required';
        if (!formData.lastExamName) errors.lastExamName = 'Last Exam Name is required';
        if (!formData.obtainedMarks) errors.obtainedMarks = 'Obtained Marks is required';
        if (!formData.universityAndBoardId) errors.universityAndBoardId = 'Board/University is required';
        if (!formData.totalMarks) errors.totalMarks = 'Total Marks is required';
        if (!formData.result) errors.result = 'Result is required';


        // If any errors, show them and stop here
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }

        const requestBody = {
            courseId: courseId.courseId,
            isAppear: formData.isAppear === 'true',
            lastExamName: formData.lastExamName,
            universityAndBoardId: selectedUniversity,
            college: formData.college,
            passingYear: formData.passingYear || " ",
            obtainedMarks: formData.obtainedMarks,
            totalMarks: formData.totalMarks,
            stream: formData.stream,
            gap: formData.gap === 'true',
            lastExamSeatNo: formData.lastExamSeatNo,
            result: formData.result,
            percentage: parseFloat(formData.percentage)
        };

        console.log("request body", requestBody);

        try {
            const response = await PostLastQualifyingDetails(requestBody, token, studentId);
            console.log('Data saved successfully:', response.data);
            if (response.status === 200) {
                toast.success("Details saved successfully !")
            } else {
                toast.error("Error saving data.")
            }
        } catch (error) {
            console.error('Error saving data:', error);
            setError('Error saving data.');
        }
    };
    return (
        <>
            <Container fluid>
                <Row className='mt-4'>
                    <Col >
                        <Card> <div style={{ textAlign: "center" }}>
                            <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }}
                                className='mb-3 mt-2'> Last Qualifying Exam Details</Form.Label>
                        </div>
                            <Card.Body>
                                <Row>
                                    <Col>
                                        <Form>
                                            <Row>
                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className="mb-2">
                                                        <Form.Group className="mb-2">
                                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Is Appear</Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    inline
                                                                    label="Yes"
                                                                    name="isAppear"
                                                                    type="radio"
                                                                    id="isAppearYes"
                                                                    value="true"
                                                                    checked={formData.isAppear === "true"}
                                                                    onChange={handleChange}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="No"
                                                                    name="isAppear"
                                                                    type="radio"
                                                                    id="isAppearNo"
                                                                    value="false"
                                                                    checked={formData.isAppear === "false"}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>Passing Year<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select type="text" value={formData.passingYear || ""}
                                                                onChange={handleChange}
                                                                name="passingYear">
                                                                <option> Select Passing Year</option>
                                                                {generateYearOptions().map((year) => (
                                                                    <option key={year} value={year}>
                                                                        {year}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.passingYear && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.passingYear}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className="mb-2">
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label className="me-3" style={{ marginBottom: 15 }}>Education Gap<span className="text-danger">*</span></Form.Label>
                                                            <div>
                                                                <Form.Check
                                                                    inline
                                                                    label="Yes"
                                                                    name="gap"
                                                                    type="radio"
                                                                    id="isAppearYes"
                                                                    value="true"
                                                                    checked={formData.gap === "true"}
                                                                    onChange={handleChange}
                                                                />
                                                                <Form.Check
                                                                    inline
                                                                    label="No"
                                                                    name="gap"
                                                                    type="radio"
                                                                    value="false"
                                                                    checked={formData.gap === "false"}
                                                                    onChange={handleChange}
                                                                />
                                                            </div>
                                                        </Form.Group>
                                                    </Row>
                                                </Col>
                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Last Exam Name<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter last Exam Name"
                                                                value={formData.lastExamName}
                                                                onChange={handleChange}
                                                                name='lastExamName'
                                                            />
                                                            {errors.lastExamName && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.lastExamName}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Obtained Marks<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Obtained Marks"
                                                                name='obtainedMarks'
                                                                value={formData.obtainedMarks}
                                                                onChange={handleChange} />
                                                            {errors.obtainedMarks && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.obtainedMarks}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Last Exam Seat No.</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Last Exam Seat No."
                                                                name='lastExamSeatNo'
                                                                value={formData.lastExamSeatNo}
                                                                onChange={handleChange} />
                                                            {errors.lastExamSeatNo && <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>{errors.lastExamSeatNo}</div>}
                                                        </Form.Group>
                                                    </Row>
                                                </Col>
                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Board/University<span className="text-danger">*</span></Form.Label>
                                                            <Form.Select
                                                                type="text"
                                                                id="selectedUniversity"
                                                                required
                                                                name="selectedUniversity"
                                                                value={formData.universityAndBoardId || ''}
                                                                onChange={handleBoardChange}
                                                            >
                                                                <option value="">Select University</option>
                                                                {university.map((data) => (
                                                                    <option key={data.id} value={data.id}>
                                                                        {data.universityBoardName}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            {errors.universityAndBoardId && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.universityAndBoardId}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Total Marks<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Total Marks"
                                                                name='totalMarks'
                                                                value={formData.totalMarks}
                                                                onChange={handleChange} />
                                                            {errors.totalMarks && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.totalMarks}
                                                                </div>
                                                            )}
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Result<span className="text-danger">*</span></Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Result"
                                                                name='result'
                                                                value={formData.result}
                                                                onChange={handleChange} />
                                                            {errors.result && (
                                                                <div style={{ color: 'red', fontSize: '13px', marginTop: '3px' }}>
                                                                    {errors.result}
                                                                </div>
                                                            )}

                                                        </Form.Group>
                                                    </Row>
                                                </Col>
                                                <Col xl={3} lg={3} md={3} xs={12} s={12}>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2">
                                                            <Form.Label>School/College</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter School/College"
                                                                name='college'
                                                                value={formData.college}
                                                                onChange={handleChange} />
                                                        </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Stream</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Result"
                                                                name='stream'
                                                                value={formData.stream}
                                                                onChange={handleChange} />
                                                            {errors.stream && <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>{errors.stream}</div>}                                                       </Form.Group>
                                                    </Row>
                                                    <Row className='mb-2'>
                                                        <Form.Group className="mb-2" >
                                                            <Form.Label>Percentage</Form.Label>
                                                            <Form.Control type="text" placeholder="Enter Percentage"
                                                                name='percentage'
                                                                value={formData.percentage}
                                                                onChange={handleChange} />
                                                            {errors.percentage && <div style={{ color: "red", fontSize: "13px", marginTop: "3px" }}>{errors.percentage}</div>}                                                        </Form.Group>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className="d-flex align-items-center justify-content-center mb-3 mt-4">
                                        <Button variant="primary" type="button" onClick={handleSave}
                                        >
                                            Save
                                        </Button>
                                        <ToastContainer />
                                    </Col>
                                </Row>

                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default LastQualifyingExam;